import React from 'react';

import { KeyOutlined, SafetyOutlined, UserOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const NineOneAppCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const apiKeyDirty = useDirtyMaskedField(form, [ 'credentials', 'api_key' ], isEditing);

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'code']}
            label={t('models.ec_account.platform_settings.nine_one_app.code')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.nine_one_app.code_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.nine_one_app.code_placeholder')}
              prefix={<SafetyOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_key']}
            label={t('models.ec_account.platform_settings.nine_one_app.api_key')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.nine_one_app.api_key_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.nine_one_app.api_key_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={apiKeyDirty}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'sender_name']}
            label={t('models.ec_account.platform_settings.nine_one_app.sender_name')}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.nine_one_app.sender_name_placeholder')}
              prefix={<UserOutlined />}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default NineOneAppCredentials;
